import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isArray',
})
export class IsArrayPipe implements PipeTransform {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  transform(list: any): boolean {
    return Array.isArray(list);
  }
}
